import { Entitlements, SET_ENTITLEMENTS } from './entitlementsConstants'

export const entitlementsReducer = (
  state = ['loading_entitlements'],
  action: { type: string; payload?: Entitlements }
) => {
  switch (action.type) {
    case SET_ENTITLEMENTS:
      return action.payload || []
    default:
      return state
  }
}
